<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import HeaderNav from "@/components/headerNav.vue";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

import FootNav from "@/components/footNav.vue";
import banner1 from "@/assets/temporary/banner001.jpg";
import banner2 from "@/assets/temporary/banner010.jpg";
import {getBannerApi, getNewsArticleApi} from "@/api";
let data = ref({})
const bannerList = ref([
  { id: 1, title: '轮播图1' ,
    img: banner1
  },
  {
    img:banner2,id:2 ,title:'轮播图2'
  }
])
function  getBanner (){
  getBannerApi({type:7}).then(res => {
    bannerList.value = res.data
  })
}
const router = useRouter()
const id = router.currentRoute.value.query.id
function getDetails () {
  getNewsArticleApi({id}).then(res => {
    data.value = res.data
  })
}
getBanner ()
getDetails()
</script>

<template>

  <HeaderNav :isCurrent="6" />
  <div>
    <!-- 轮播图 -->
    <el-carousel height="auto" autoplay>
      <el-carousel-item style="height: auto ;min-height: 600px" v-for="(item ,index) in bannerList" :key="index">
        <img :src="item.picUrl" :alt="item.title">
      </el-carousel-item>
    </el-carousel>
  </div>
  <div class="box">
    <!--主体内容 开始-->
    <div class="download">
      <!--右侧区域 开始-->
      <div id="right">
        <div class="right_title"></div>
        <div class="right_body">
          <div class="InfoTitle"><h1>{{data.title}}</h1></div>
          <div class="info_from_wrap">
            <b>{{t('来源')}} ：</b><a href="javascript:;">行业动态</a> <b>{{t('创建时间')}} ：</b>2021-08-23 15:41:16                <b>{{t('点击量')}}：</b>18
          </div>
          <!-- 文章内容  开始-->
          <div class="InfoSContent"></div>
          <div class="InfoContent">
            <div>
               <div v-html="data.content"></div>
              <!-- <p>徐工印度公司在印度庆祝“第2000台挖掘机下线”的消息引起了广泛关注。这标志着徐工在印度本地化制造取得了重要的里程碑。庆典活动在杜尔迦节前夕举行，徐工印度公司总经理涂晖带领管理团队和工人出席了活动。仪式上融合了当地宗教民俗普迦仪式，现场气氛热烈。通过这一消息，我们了解到徐工印度公司在本地化制造方面取得了显著成就，同时也引发了对于徐工在印度市场面临的挑战和风险的讨论。</p><p>自从徐工印度公司于2021年12月31日正式投产以来，他们一直积极推进本地化战略。据我们了解，徐工印度公司引入了经验丰富的管理人员和工人，同时建立了成熟的本地化团队。他们致力于提升产品质量和竞争力，建立了稳定的供应体系，并与当地供应商、日韩供应商和国内供应商合作。这些举措有助于徐工在海外制造基地扎根，并构建了全球供应链体系。</p><p>然而，这条消息引发了一些网友对于徐工在印度市场的担忧。他们认为徐工可能会面临割韭菜的待遇。然而，我们认为这种观点过于片面。开拓海外市场是每个企业必然要面对的任务，只有通过占领这个市场，企业才能实现规模和实力的扩张。如果不去拓展海外市场，企业将被其他竞争对手抢先占领。所以，徐工在印度本地化制造的努力是值得称赞的。然而，高额的海外投资必须慎重考虑风险。</p><p>这种风险不仅仅涉及到企业自身，也关乎国家利益。在面对战略意义和规模庞大的海外项目和投资时，单纯的市场经济是不够的。国家监管和控制的加强是必要的，计划经济的成分也应该考虑进来。只从企业的角度思考问题，未来可能面临巨大的风险。就徐工在印度的本地化工程机械生产而言，我们目前了解的信息有限，无法作出准确的评判或发表观点。但是，我们希望徐工在海外市场发展中能够谨慎行事。</p><p>在面对挑战和风险时，始终保持清醒的头脑和明智的决策是非常重要的。徐工作为中国企业在海外市场的代表，应该充分考虑市场环境和风险状况，坚持稳健发展的原则。总之，徐工印度公司庆祝“第2000台挖掘机下线”的消息引起了广泛关注。他们在印度本地化制造方面取得的成就令人瞩目。开拓海外市场是必须要面对的任务，但也需要慎重考虑风险。</p><p>我们希望徐工能够继续努力，做出明智的决策，并在海外市场取得更大的成功。最后，我们想询问读者，在企业在海外市场发展中所面临的挑战和风险方面，你有何看法？请留下你的评论。</p>                 -->
            </div>
          </div>
          <!-- 文章内容  结束-->

          <!-- 当前信息 上一条 下一条  开始-->
          <div class="info_previous_next_wrap">
            <div class="Previous">
              <b>上一条：</b>
              <a href="/yccms/journalism/details/8/7.html" title="批量交付！近20台徐工大吨位挖掘机“掘金”绿色矿山">批量交付！近20台徐工大吨位挖掘机“掘金”�...</a>
            </div>
            <div class="Next">
              <b>下一条：</b>
              <a href="/yccms/journalism/details/8/13.html" title="势如破竹！徐工助力雅加达开启“地铁新时代”">势如破竹！徐工助力雅加达开启“地铁新时代...</a>
            </div>
          </div>
          <!-- 当前信息 上一条 下一条  结束-->
        </div>
        <div class="right_bottom"></div>
      </div>
      <!--右侧区域 结束-->
      <div class="clear"></div>
    </div>
        <!--主体内容 结束-->
    <div>
      <FootNav />
    </div>
  </div>
</template>

<style scoped lang="scss">
.video-details {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;

  h1 {
    color: #333;
    margin-bottom: 20px;
  }

  .video-container {
    margin-top: 20px;
    padding: 20px;
    background-color: #f5f5f5;
    border-radius: 8px;
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>